import React from 'react';

import Icon from '../Icon/Icon';

const SyncBlueIcon = (props) => {
    return (
        <Icon width='46' height='54' {...props}>
            <g strokeWidth='2.5' fill='none' fillRule='evenodd' strokeLinecap='round'>
                <path
                    d='M34.764 9.194A21.234 21.234 0 0 0 23 5.66c-11.782 0-21.333 9.551-21.333 21.333 0 3.96 1.079 7.668 2.959 10.846'
                    stroke='#34303D'
                />
                <path
                    d='M22.151 11.057C13.89 11.749 7.4 18.674 7.4 27.114c0 2.991.815 5.792 2.235 8.193M23.85 42.94c8.262-.692 14.751-7.617 14.751-16.057a16.04 16.04 0 0 0-2.235-8.193'
                    stroke='#00D1D2'
                />
                <path
                    d='M11.242 44.797A21.234 21.234 0 0 0 23 48.327c11.782 0 21.333-9.552 21.333-21.334 0-3.947-1.072-7.643-2.94-10.814M27.312 12.277l8.095-2.169-2.17-8.095'
                    stroke='#34303D'
                />
                <path stroke='#34303D' d='m18.743 41.717-8.095 2.17 2.17 8.094' />
            </g>
        </Icon>
    );
};

export default SyncBlueIcon;
